export default "__VITE_ASSET__DFuhAyhj__"